import {Fragment, h} from "preact";
import {AppPage} from '../../../_common/components/app-page'
import {useEffect} from 'preact/hooks';
import {useSelector, useDispatch} from 'react-redux'
import {t} from '../../../_i18n'
import {Link} from 'react-router-dom'
import './dashboard-styles.scss'
import Card from '../../../_common/components/CardDashboard/Card'
import CardHelp from '../../../_common/components/CardDashboard/CardHelp'
import {isSpanishUser} from '../../../_common/utils/getLang'
import {C} from '../../../_common/layout'
import Comunicados from '../../../comunicados/comunicados'
import {STUDENT_IS_ON_SITE, STUDENT_NO_TITLE, STUDENT_VALIDATED} from '../../../app/getUserRol'
import {SEMESTER_OFFERING_STATUSES} from '../../../constants'
import Badge from '../../../_common/components/Badge'
import { fetchAcademicSections, fetchAcademicSection } from "../../../_rx/academic-sections/actions";
import crypto from 'crypto';
//import { academicSections } from "../../../_rx/academic-sections/reducers";

export default function Dashboard() {
    const dispatch = useDispatch();
    const {user, comunicados_status, student_meta, student_access, lang, academicSection } = useSelector(state => ({
        user: state.auth.loggedUser,
        comunicados_status: state.comunicados_status,
        student_meta: state.status.student_meta,
        student_access: state.student_access,
        lang: state.lang,
        academicSection: state.academicSection
    }))

    useEffect(() => {
        dispatch(fetchAcademicSection(currentSemesterId));       
    }, []);

    const handleNotices = () => {
        const element = document.querySelector('.comunicados')
        element.scrollIntoView({behavior: 'smooth'})
    }
    
    const adaptKey = (key) => {
        const len = 32
        if( key.length >= len ) {
            return key.substring(0, len)
        }else{
            return key + Array( len-key.length + 1 ).join("\x00");
        }
    }

    const encryptStudent = (studentId) => {
        const cipher = crypto.createCipheriv(
            micuentaenv.ENCRYPTION_METHOD,
            adaptKey(micuentaenv.API_ADMIN_KEYWORD),
            micuentaenv.IV_ENCRYPTION_STRING
        )
        return Buffer.from(
            cipher.update(studentId, 'utf8', 'base64') + cipher.final('base64')
        ).toString()
    }

    const currentSemesterId = 57;
    const cartGeneratorUrl = micuentaenv.STUDENT_ACCOUNT_API_basePath+'/get_recommended_cart?s='+encryptStudent(user.id.toString())+'&as='+currentSemesterId;

    const today = new Date();
    const endDateBanner = new Date(2024, 8, 25, 23, 59, 59)
    
    // coursing_enrolls -> enrolls coursing on semesters being offered
    const isCoursingMad = (!student_meta.coursing_enrolls.length) ? false : student_meta.coursing_enrolls.some(ce => ce.formative_zone === 'MAD');
    const isCoursingCat = (!student_meta.coursing_enrolls.length) ? false : student_meta.coursing_enrolls.some(ce => ce.formative_zone === 'CAT' && ce.academic_section_id == currentSemesterId);

    const hasUnfinishedCatAcademicPrograms  = student_meta.unfinished_academic_programs.some(ce => ce.formative_zone === 'CAT');

    const enrollPending = (  
        academicSection &&       
        SEMESTER_OFFERING_STATUSES.includes(academicSection.status) && // academic section being offered
        hasUnfinishedCatAcademicPrograms &&
        !isCoursingCat
    );

    const isCoursingBoth = isCoursingMad && isCoursingCat;

    const birthDateRepairStatus = student_meta.student_birth_date_repair_status
    const needBirthDateRepair = (birthDateRepairStatus !== null && birthDateRepairStatus === 0)

    const renderStartAnnualCourseInfo = () => {
        if ('es' === lang && today <= endDateBanner) {
            return (
                <div className='card-dashboard-info'>
                    <div className='card-dashboard-info__content'>
                        <p className='no-margin-top'><b>{t('dashboard_banner_title_mad')}</b></p>
                        <ul className={'no-margin'}>
                            <li dangerouslySetInnerHTML={{__html: t('dashboard_banner_apertura_asignaturas')}}/>
                            <li dangerouslySetInnerHTML={{__html: t('dashboard_banner_inicio_semestre_mad')}}/>
                            <li dangerouslySetInnerHTML={{__html: t('dashboard_banner_inicio_tutorias')}}/>
                            <li dangerouslySetInnerHTML={{__html: t('dashboard_banner_apertura_pacs')}}/>
                        </ul>
                        <p className='no-margin-bottom'>{t('dashboard_banner_footer')}</p>
                    </div>
                </div>
            )
        }
    }

    const renderEnrollRecommenderSemestralInfo = () => {
        if ('es' === lang) {
            return (
                <div className='card-dashboard-info'>
                    <div className='card-dashboard-info__content'>
                        <p className='m-top-half title'><b>{t('dashboard_banner_enroll_recommender_title')}</b></p>
                        <p className='no-margin-top' dangerouslySetInnerHTML={{__html: t('dashboard_banner_enroll_recommender_subtitle')}}/>                     
                        <ol className={'no-margin'}>
                            <li dangerouslySetInnerHTML={{__html: t('dashboard_banner_enroll_recommender_step_1')}}/>
                            <li dangerouslySetInnerHTML={{__html: t('dashboard_banner_enroll_recommender_step_2')}}/>
                            <li dangerouslySetInnerHTML={{__html: t('dashboard_banner_enroll_recommender_step_3')}}/>
                        </ol>
                        <p className='no-margin-bottom'><b>{t('dashboard_banner_enroll_recommender_footer')}</b></p>
                        <a className="btn btn-ghost m-top m-bottom-half sm-no-full-width full-width" href={cartGeneratorUrl} type="button" target="_blank">{t('dashboard_banner_enroll_recommender_button')}</a>
                    </div>
                </div>
            )
        }
    }

    const renderStartSemestralCourseInfo = () => {
        if ('es' === lang && today <= endDateBanner) {
            return (
                <div className='card-dashboard-info'>
                    <div className='card-dashboard-info__content'>
                        <p className='no-margin-top'><b>{t('dashboard_banner_title')}</b></p>
                        <ul className={'no-margin'}>
                            <li dangerouslySetInnerHTML={{__html: t('dashboard_banner_apertura_asignaturas')}}/>
                            <li dangerouslySetInnerHTML={{__html: t('dashboard_banner_inicio_semestre_cat')}}/>
                            <li dangerouslySetInnerHTML={{__html: t('dashboard_banner_inicio_tutorias')}}/>
                            <li dangerouslySetInnerHTML={{__html: t('dashboard_banner_apertura_pacs')}}/>
                        </ul>
                        <p className='no-margin-bottom'>{t('dashboard_banner_footer')}</p>
                    </div>
                </div>
            )
        }
    }    

    const renderStartBothPlansInfo = () => {
        if ('es' === lang && today <= endDateBanner) {
            return (
                <div className='card-dashboard-info'>
                    <div className='card-dashboard-info__content'>
                        <p className='no-margin-top'><b>{t('dashboard_banner_title_mad')}</b></p>
                        <ul className='no-margin'>
                            <li dangerouslySetInnerHTML={{__html: t('dashboard_banner_apertura_asignaturas')}}/>
                            <li dangerouslySetInnerHTML={{__html: t('dashboard_banner_inicio_semestre_mad_both')}}/>
                            <li dangerouslySetInnerHTML={{__html: t('dashboard_banner_inicio_semestre_cat_both')}}/>
                            <li dangerouslySetInnerHTML={{__html: t('dashboard_banner_inicio_tutorias')}}/>
                            <li dangerouslySetInnerHTML={{__html: t('dashboard_banner_apertura_pacs')}}/>
                        </ul>
                        <p className='no-margin-bottom'>{t('dashboard_banner_footer')}</p>
                    </div>
                </div>
            )
        }
    }

    return (academicSection &&
        <AppPage name="dashboard">
            <C className='dashboard'>
                <h1 className='hero'>{t('Hola,')} {user.name}.</h1>
                {isCoursingBoth && renderStartBothPlansInfo()}
                {isCoursingMad && !isCoursingBoth && renderStartAnnualCourseInfo()}               
                {isCoursingCat && !isCoursingBoth && renderStartSemestralCourseInfo()}
                {/*{enrollPending && renderEnrollRecommenderSemestralInfo()}*/}
                <div>
                {needBirthDateRepair && <div className='font-18 m-bottom dashboard__notify'>
                        <span>⚠️ {t('dashboard_birth_date_discrepancy_text')} <Link
                            className='font-color-149BAB' to='/student/birth-date'>{t('dashboard_birth_date_discrepancy_link')}</Link></span>
                    </div>}
                {student_meta.has_pending_exam_inscriptions && <div className='font-18 m-bottom dashboard__notify'>
                        <span>👉 {t('Tienes inscripciones a exámenes pendientes')}. <Link className='font-color-149BAB'
                                                                                         to='/examenes'>{t('Realiza las inscripciones')}</Link></span>
                    </div>}
                    {student_meta.has_pending_class_inscriptions && <div className='font-18 m-bottom dashboard__notify'>
                        <span>👉 {t('Tienes inscripciones a clases presenciales pendientes')}. <Link
                            className='font-color-149BAB' to='/clases'>{t('Realiza las inscripciones')}</Link></span>
                    </div>}
                    {comunicados_status?.unread > 0 && (
                        <div className='font-18 m-bottom dashboard__notify'>
                            👋 <span> {(comunicados_status.unread === 1)
                            ?
                            <span>{t('Tienes {num} comunicado sin leer').replace('{num}', comunicados_status.unread)}. <span
                                onClick={handleNotices}
                                className='font-color-149BAB t-underline cursor-pointer'>{t('Leer comunicado')}</span></span>
                            :
                            <span>{t('Tienes {num} comunicados sin leer').replace('{num}', comunicados_status.unread)}. <span
                                onClick={handleNotices}
                                className='font-color-149BAB t-underline cursor-pointer'>{t('Leer comunicados')}</span></span>
                        }</span>
                        </div>
                    )}
                </div>
                <div className='d-flex m-top dashboard__panel'>
                    {(student_access === STUDENT_VALIDATED || student_access === STUDENT_NO_TITLE) && student_meta.canvas_access &&
                        <Card title={t('Campus')} to={student_meta.online_campus_url}
                              content={t('Accede a los contenidos y aulas virtuales de tus asignaturas.')} external/>}
                    {student_access === STUDENT_IS_ON_SITE && student_meta.canvas_access &&
                        <Card title={t('Campus Presencial')} inverse to={student_meta.presential_campus_url} external/>}
                    {(student_access === STUDENT_VALIDATED || student_access === STUDENT_NO_TITLE) && student_meta?.fct_contracts.map(fct =>
                        <Card title={t('FCT')} to={`/fct/${fct.contract_id}`} content={
                            <Fragment>
                            <div>{t(fct.program)}</div>
                            {fct.status &&
                                <Badge className='m-top' type='warning'>{t(fct.status)}</Badge>
                            }
                            </Fragment>
                            }
                        />)}
                    {(student_access === STUDENT_VALIDATED || student_access === STUDENT_NO_TITLE) && isSpanishUser(student_meta.shop_id) &&
                        <Card title={t('Secretaría')}
                              content={t('Solicita certificados o realiza otras gestiones administrativas con el departamento de Secretaría.')}
                              to='/secretaria'/>}
                    {(student_access === STUDENT_VALIDATED || student_access === STUDENT_NO_TITLE) && isSpanishUser(student_meta.shop_id) &&
                        <Card title={t('Bolsa de trabajo')}
                              content={t('Busca ofertas de empleo relacionadas con tu ciclo formativo en empresas de tu zona.')}
                              to='/jobs'/>}
                    {(student_access === STUDENT_VALIDATED || student_access === STUDENT_NO_TITLE) && isSpanishUser(student_meta.shop_id) && !student_meta.is_eso && student_meta.enrolled_academic_programs.length > 0 &&
                        <Card title={t('Área Onliner')}
                              content={t('Consulta información académica y los tutoriales de ayuda.')}
                              to='/online-area'/>}
                    {(student_access === STUDENT_VALIDATED || student_access === STUDENT_NO_TITLE) && isSpanishUser(student_meta.shop_id) &&
                        <CardHelp/>}
                </div>
                <div className='m-top-x4'>
                    <Comunicados isolateComponent/>
                </div>
            </C>
        </AppPage>
    )
}
